export default __webpack_public_path__ + "static/media/16-ART-(1-1).650991f3.jpg";